import { render, staticRenderFns } from "./MultiProfessionListUserFilter.vue?vue&type=template&id=627f14dc&scoped=true&"
import script from "./MultiProfessionListUserFilter.vue?vue&type=script&lang=ts&"
export * from "./MultiProfessionListUserFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f14dc",
  null
  
)

export default component.exports